import React from "react"
import { FormField } from "src/features/calculator/components/field/FormField"
import styled from "styled-components"

type Props = {
  customerTransferFeeRate: number
}

export function FixedCustomerTransferFeeRateRow({ customerTransferFeeRate }: Props) {
  return (
    <StyledCalculatorRowDiv>
      <FormField
        label="送客手数料率(税込)"
        type="number"
        placeholder="Placeholder"
        hint={`${customerTransferFeeRate}%`}
        disabled
        value={customerTransferFeeRate}
      />
      <span>= {customerTransferFeeRate}</span>
    </StyledCalculatorRowDiv>
  )
}

const StyledCalculatorRowDiv = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`
